export default "__VITE_ASSET__BYdKpq87__"